import MicroModal from "micromodal";
import { debounce } from "../helpers/timings";
import './form';

const modalContent = document.querySelector('.kem-modal__content');

/**
 * Initialize booking form modal.
 */
MicroModal.init({
    awaitCloseAnimation: true,
    awaitOpenAnimation: true,
    onShow: (modal) => {
        modalContent.scrollTop = 0; // Scroll to top of modal when opening
        checkScrollbar(); // Check if scrollbar is present, add class if so
    }
});

/**
 * Add class to modal if scrollbar is present. Adapt to viewport width changes.
 * This function is called on page load, viewport resize, modal content resize and modal content mutation.
 */
function checkScrollbar() {
    const modals = document.querySelectorAll('.kem-modal');

    for (const modal of modals) {
        const contentWrapper = modal.querySelector('.kem-modal__content');
        const hasScrollbar = contentWrapper.scrollHeight > contentWrapper.clientHeight;

        if (hasScrollbar) {
            modal.classList.add('kem-scrollbar');
        } else {
            modal.classList.remove('kem-scrollbar');
        }
    }
}

// Check on page load
checkScrollbar(); 

// Check on viewport resize
addEventListener('resize', debounce(checkScrollbar));

// Check on modal content resize
modalContent.addEventListener('resize', debounce(checkScrollbar));

// Check on modal content mutation
(new MutationObserver(() => checkScrollbar())).observe(modalContent, { childList: true, subtree: true }); 